import { TeacherDataService } from './../shared/teacher-data.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import {
  ColumnaMaestra,
  EspacioControl,
  TipoControl,
  BaseControl,
  ConfirmComponent,
  MaestraDependencia,
  Valores,
  CondicionControl,
  FiltrosSelectores,
  OptionsColumns,
  ColumnsTableModalSelect,
  Const,
  TablaMaestra,
  Static
} from '@app/shared';
import { MasterStructureDataService } from './shared/master-structure-data.service';
import { MasterStructureFormService } from './shared/master-structure-form.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { find } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { DragulaService } from 'ng2-dragula';
import { Logger, AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';

const log = new Logger('MasterStructureComponent');

@Component({
  selector: 'iw-master-structure',
  templateUrl: './master-structure.component.html',
  styleUrls: ['./master-structure.component.scss'],
  providers: [MasterStructureDataService, MasterStructureFormService, TeacherDataService],
})
export class MasterStructureComponent implements OnInit, OnDestroy {
  // Id de la maestra
  @Input() idMaster: number;
  // Estructura de la maestra
  // Contiene los controles del formulario
  @Input() structureMasterI: Array<ColumnaMaestra>;
  structureMaster: Array<ColumnaMaestra> = [];
  // Lista de tablas maestraas
  @Input() masterTablesI: Array<TablaMaestra> = [];
  masterTables: Array<TablaMaestra> = [];
  // Accion realizar
  action = 'Agregar';
  // Pregunta para la modal
  question = '';
  // Define la accion de respuesta de la modal
  typeAction: 'closeComponent' | 'savedStructure' | 'deleteColumn';
  // Contiene el nombre de el tipo de control a editar
  controlModelNgSelect = '';
  // orden maximo de los controles dentro del formulario
  orderControlMax = 1;
  // Index del control seleccioonado en el formulario
  indexControlSelect = -1;
  // Contiene el id de la maestra dependencia seleccionada
  idMasterSelected = -1;
  // Define si se modificara la columna
  editColumn = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    buildStructure: false,
  };
  // Contiene los ids de las columnas a eliminar de la estructura
  idColumsDelete: Array<number> = [];
  // Contiene el tipo del nuevo control a agregar
  typeNewControl: TipoControl;
  // Lista de tamaños de los controles
  sizesControls: Array<EspacioControl> = [
    {
      espacio: 4,
      nombre: 'Pequeño'
    },
    {
      espacio: 6,
      nombre: 'Mediano'
    },
    {
      espacio: 12,
      nombre: 'Grande'
    }
  ];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMaster: Array<OptionsColumns> = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMasterFilter: Array<OptionsColumns> = [];
  // Tipos de control
  typesControl: Array<TipoControl> = [];
  // Contiene temporalmente las condiciones del control selecionado
  tmpFormulariosCondictions: Array<CondicionControl> = [];
  // Contiene temporalmente los filtros del control selecionado
  tmpFormulariosFilters: Array<FiltrosSelectores> = [];
  // clase base de los controles del formulario para agregar los campos
  controls: BaseControl<any>[] = [];
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene el control seleccionado
  controlSelect: ColumnaMaestra;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;
  @ViewChild('templateAccion') private templateAccion: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // salida del evento de cerrar
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private dragulaService: DragulaService,
    private msds: MasterStructureDataService,
    private modalService: BsModalService,
    private msfs: MasterStructureFormService,
    private toastr: ToastrService,
    private tds: TeacherDataService,
    private as: AuthenticationService,
  ) {
    dragulaService.drop.subscribe((data: any) => {
      this.reorder();
    });
  }

  ngOnInit() {

    // Permiso para crear estructura de las maestras
    this.activateAction.buildStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.buildStructure,
    );

    if (this.masterTablesI && this.masterTablesI.length) {
      this.masterTablesI.forEach(table => {
        this.masterTables.push({
          id: table.id,
          alias: table.alias,
          nombre: table.nombre,
          descripcion: table.descripcion,
          usuarios: table.usuarios
        });
      });
    }
    this.structureMaster = this.getStructureMAster(this.structureMasterI);
    // Consulta tipos de controles
    this.msds.getTypesControl().subscribe(control => {
      this.typesControl = control;
    });
    if (this.structureMaster.length && this.structureMaster.length) {
      this.structureMaster.sort((a, b) => a.orden - b.orden);
      this.orderControlMax = this.getIndexMaxForm();
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  /**
   * Copia la estructura de una maestra y la retorna
   * Nota: se utiliza para eliminar la referencia de variable de javascript
   *
   * @param {Array<ColumnaMaestra>} structure
   * @returns {Array<ColumnaMaestra>}
   * @memberof MasterStructureComponent
   */
  getStructureMAster(structure: Array<ColumnaMaestra>): Array<ColumnaMaestra> {
    const structureCopy: Array<ColumnaMaestra> = [];
    if (structure && structure.length) {
      structure.forEach(column => {
        let typeColumn: number | TipoControl;
        let masterDependence: number | MaestraDependencia;

        if (column.tipo_campo) {
          if (typeof column.tipo_campo === 'number') {
            typeColumn = column.tipo_campo;
          } else {
            typeColumn = {
              id: column.tipo_campo.id,
              nombre: column.tipo_campo.nombre,
              descripcion: column.tipo_campo.descripcion,
            };
          }
        }

        if (column.maestra_dependencia) {
          if (typeof column.maestra_dependencia === 'number') {
            masterDependence = column.maestra_dependencia;
          } else {
            masterDependence = {
              id: column.maestra_dependencia.id,
              nombre: column.maestra_dependencia.nombre,
              estructura: this.getStructureMAster(column.maestra_dependencia.estructura),
              valores: [],
            };
            if (column.maestra_dependencia.valores && column.maestra_dependencia.valores.length) {
              column.maestra_dependencia.valores.forEach(value => {
                let valueCopy: Valores;
                valueCopy = {
                  id: value.id,
                  datos: Static.copyObjet(value.datos),
                };
                if (value.user_login) {
                  valueCopy.user_login = {
                    id: value.user_login.id,
                    is_active: value.user_login.is_active,
                    password: value.user_login.password,
                    username: value.user_login.username,
                  };
                }
              });
            }
          }
        }

        const columnCopy: ColumnaMaestra = {
          id: column.id ? column.id : null,
          alias: column.alias,
          nombre: column.nombre,
          placeholder: column.placeholder,
          tooltip: column.tooltip,
          espacio: column.espacio,
          validaciones: {
            condiciones: Static.copyObjet(column.validaciones.condiciones),
            filtros: Static.copyObjet(column.validaciones.filtros)
          },
          orden: column.orden,
          requerido: column.requerido,
          unico: column.unico,
          propiedades: Static.copyObjet(column.propiedades),
          tipo_campo: typeColumn,
          maestra_dependencia: masterDependence,
        };
        structureCopy.push(columnCopy);
      });
    }
    return structureCopy;
  }

  /**
   * Validar funcionalidad
   * Copia un array de tipo cualquiera y lo retorna
   * Nota: se utiliza para eliminar la referencia de variable de javascript
   *
   * @param {Array<any>} data
   * @returns {Array<any>}
   * @memberof MasterStructureComponent
   */
  private arrayCopy(data: Array<any>): Array<any> {
    const dataCopy: Array<any> = [];

    if (data && data.length) {
      data.forEach(el => {
        let copyElement: any;
        if (typeof el !== 'object') {
          copyElement = el;
        } else {
          copyElement = this.dataRow(el);
        }
        dataCopy.push(copyElement);
      });
    }

    return dataCopy;
  }

  /**
   * copia un objeto de tipo any y lo retorna
   * Nota: se utiliza para eliminar la referencia de variable de javascript
   *
   * @param {*} data
   * @returns {*}
   * @memberof MasterStructureComponent
   */
  dataRow(data: any): any {
    const dataCopy = {};
    Object.keys(data).forEach(key => {
      dataCopy[key] = data[key];
    });
    return dataCopy;
  }

  /**
   * Retorna el orden maximo en las columnas de la estructura
   *
   * @private
   * @returns {number}
   * @memberof MasterStructureComponent
   */
  private getIndexMaxForm(): number {
    let orderMax = 0;
    this.structureMaster.forEach(f => {
      if (f.orden > orderMax) {
        orderMax = f.orden;
      }
    });
    return orderMax + 1;
  }

  /**
   * Emite el evento de cierre del componente
   *  retorna true  = se ejecuto despues del evento de guardar estructura
   *          false = accion de cerrar el componente
   *
   * @param {boolean} [res=false]
   * @memberof MasterStructureComponent
   */
  closeComponent(res: boolean = false) {
    this.orderControlMax = 1;
    this.idMaster = -1;
    this.indexControlSelect = -1;
    this.structureMaster = [];
    this.close.emit(res);
  }

  /**
   * Abre el formulario de las columnas cuando es una nueva o si es un una accion a uan columna ya agregada
   * abre el modal de acciones
   *
   * @param {boolean} [add=true]
   * @param {ColumnaMaestra} [controlSelection]
   * @param {number} [indexSelect]
   * @memberof MasterStructureComponent
   */
  openForm(add: boolean = true, controlSelection?: ColumnaMaestra, indexSelect?: number) {
    if (add) {
      this.action = 'Agregar';
      this.modalRef = this.modalService.show(this.template, { class: 'modal-lg-personalized' });
      this.controls = [];
      this.indexControlSelect = -1;
      this.editColumn = false;
      this.controlModelNgSelect = null;
    } else {
      if (this.activateAction.buildStructure) {
        this.action = 'Editar';
        this.controlSelect = controlSelection;
        this.editColumn = true;
        this.indexControlSelect = indexSelect;
        this.modalRef = this.modalService.show(this.templateAccion, { class: 'modal-md' });
        this.controlModelNgSelect = this.controlSelect ?
          this.controlSelect.tipo_campo ?
            this.controlSelect.tipo_campo['nombre'] ?
              this.controlSelect.tipo_campo['nombre']
              : null
            : null
          : null;
      } else {
        this.toastr.error(
          'Usted no posee permisos de construcción de estructura de la tabla maestra',
          'Permiso denegado'
        );
      }
    }
  }

  /**
   * Cierra el modal actual abierto y reinicia las variables de edicion de columna
   *
   * @memberof MasterStructureComponent
   */
  closeForm() {
    this.controlModelNgSelect = null;
    this.indexControlSelect = -1;
    this.idMasterSelected = -1;
    this.editColumn = false;
    delete this.controlSelect;
    delete this.typeNewControl;
    this.controls = [];
    this.modalRef.hide();
  }

  /**
   * Abre el formulario de edicion de columna de la estructura
   *
   * @memberof MasterStructureComponent
   */
  openEditColumna() {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(this.template, { class: 'modal-lg-personalized' });
    this.getFormControl(
      this.controlSelect ?
        this.controlSelect.tipo_campo ?
          this.controlSelect.tipo_campo
          : null
        : null
    );
  }

  /**
   * Eimina una columna de la estructura de la maestra
   *
   * @memberof MasterStructureComponent
   */
  deleteColumn() {
    this.structureMaster.splice(this.indexControlSelect, 1);
    if (this.controlSelect && this.controlSelect.id) {
      this.idColumsDelete.push(this.controlSelect.id);
    }
    this.closeForm();
  }

  /**
   * Controla los diferentes formularios de las columnas dependiendo del tipo de campo seleccionado
   * Carga la informacion de la columna seleccionada si es el caso
   *
   * @param {*} [data]
   * @memberof MasterStructureComponent
   */
  async getFormControl(data?: any) {
    this.modalService.onHidden.subscribe((response: any) => {
      if (response === 'backdrop-click') {
        this.indexControlSelect = -1;
        this.idMasterSelected = -1;
        this.editColumn = false;
        delete this.controlSelect;
      }
    });
    this.typeNewControl = null;
    this.controls = [];

    if (data) {
      setTimeout(async () => {
        switch (data.nombre) {
          case 'text':
          case 'password':
            if (this.editColumn) {
              this.controls = this.msfs.getFormText(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.msfs.getFormText(this.sizesControls);
            }
            break;
          case 'number':
            if (this.editColumn) {
              this.controls = this.msfs.getFormNumber(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.msfs.getFormNumber(this.sizesControls);
            }
            break;
          case 'textarea':
            if (this.editColumn) {
              this.controls = this.msfs.getFormTextArea(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.msfs.getFormTextArea(this.sizesControls);
            }
            break;
          case 'checkbox':
            if (this.editColumn) {
              this.controls = this.msfs.getFormCheck(this.controlSelect);
            } else {
              this.controls = this.msfs.getFormCheck();
            }
            break;
          case 'email':
            if (this.editColumn) {
              this.controls = this.msfs.getFormEmail(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.msfs.getFormEmail(this.sizesControls);
            }
            break;
          case 'date-time-picker':
            if (this.editColumn) {
              this.controls = this.msfs.getFormDate(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.msfs.getFormDate(this.sizesControls);
            }
            break;
          case 'ngSelect':
            if (this.editColumn) {
              if (this.controlSelect.maestra_dependencia) {
                if (this.idMasterSelected !== this.controlSelect.maestra_dependencia) {
                  if (typeof this.controlSelect.maestra_dependencia === 'number') {
                    this.idMasterSelected = this.controlSelect.maestra_dependencia;
                  } else {
                    this.idMasterSelected = this.controlSelect.maestra_dependencia['id'];
                  }
                }
              }
              if (this.idMasterSelected > 0) {
                const master = await this.tds.getInformacionMasterTable(this.idMasterSelected, true);

                this.columnsMaster = this.loadingColumnsViews(master.estructura, this.idMasterSelected);
                this.columnsMasterFilter = this.loadingColumnsViews(master.estructura, this.idMasterSelected, true);

                this.controls = this.msfs.getFormSelect(
                  this.sizesControls,
                  this.masterTables,
                  this.ngSelectTpl,
                  this.controlSelect,
                  this.columnsMaster
                );
              } else {
                this.controls = this.msfs.getFormSelect(
                  this.sizesControls,
                  this.masterTables,
                  this.ngSelectTpl,
                  this.controlSelect
                );
              }
            } else {
              this.controls = this.msfs.getFormSelect(this.sizesControls, this.masterTables, this.ngSelectTpl);
            }
            break;
        }
        this.typeNewControl = data;
      });
    }
  }

  /**
   * Carga la informacion de las columnas de la maestra seleccionada para mostrarla en el ngSelect
   *
   * @param {ColumnaMaestra[]} structure
   * @param {number} idmaster
   * @param {boolean} [idestruture=false]
   * @returns {Array<OptionsColumns>}
   * @memberof MasterStructureComponent
   */
  loadingColumnsViews(
    structure: ColumnaMaestra[],
    idmaster: number,
    idestruture: boolean = false
  ): Array<OptionsColumns> {

    const mastersC: Array<OptionsColumns> = [];
    const masterName = find(this.masterTables, { id: Number(idmaster) });

    structure.forEach(async etr => {
      if (etr.tipo_campo['nombre'] === 'ngSelect') {
        if (idestruture) {
          const column: OptionsColumns = {
            key: etr.nombre,
            value: String(etr.id),
            masterDependencia: masterName.nombre,
            column: etr.nombre,
            type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
          };
          if (column.type === 'date-time-picker') {
            column.category = etr.propiedades['tipo'];
          }
          mastersC.push(column);
        }
        if (typeof etr.maestra_dependencia === 'object' && etr.maestra_dependencia.estructura) {
          // tslint:disable-next-line:max-line-length
          const otherMaster: Array<OptionsColumns> = this.loadingColumnsViews(
            etr.maestra_dependencia.estructura,
            etr.maestra_dependencia.id,
            idestruture
          );
          otherMaster.forEach(el => {
            const column: OptionsColumns = {
              key: el.key,
              value: etr.id + '_' + el.value,
              masterDependencia: el.masterDependencia,
              column: etr.nombre,
              type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
            };
            if (column.type === 'date-time-picker') {
              column.category = etr.propiedades['tipo'];
            }
            mastersC.push(column);
          });
        }
      } else {
        const column: OptionsColumns = {
          key: etr.nombre,
          value: String(etr.id),
          masterDependencia: masterName.nombre,
          column: etr.nombre,
          type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
        };
        if (column.type === 'date-time-picker') {
          column.category = etr.propiedades['tipo'];
        }
        mastersC.push(column);
      }
    });

    return mastersC;
  }

  /**
   * Guarda o edita la columna de la estructura segun sea el caso con la informacion llenada en el formulario
   *
   * @param {*} data
   * @param {('agregar' | 'editar')} [action='agregar']
   * @memberof MasterStructureComponent
   */
  async saveControl(data: any, action: 'agregar' | 'editar' = 'agregar') {
    let newControl: ColumnaMaestra;
    let valid = true;
    let duplicateAlias = false;
    const infoAlias = find(this.structureMaster, { alias: data.txtAlias });

    if (infoAlias) {
      if (action === 'agregar') {
        duplicateAlias = true;
      } else {
        if (infoAlias.orden !== this.controlSelect.orden) {
          duplicateAlias = true;
        }
      }
    }
    if (!duplicateAlias) {
      switch (this.typeNewControl.nombre) {
        case 'text':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                'Información errónea');
              break;
            }
          }
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            orden: 0,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            propiedades: {
              max: data.txtMax,
              min: data.txtMin,
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp,
              transform: data.cboTransform,
            },
            unico: data.chOnly,
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          break;
        case 'number':
        case 'password':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              if (this.typeNewControl.nombre === 'number') {
                this.toastr.warning('El valor mínimo no puede ser mayor al valor máximo.',
                  'Información errónea');
              } else {
                this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                  'Información errónea');
              }
              break;
            }
          }
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            orden: 0,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            propiedades: {
              max: data.txtMax,
              min: data.txtMin,
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp,
            },
            unico: data.chOnly,
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          if (this.typeNewControl.nombre === 'number') {
            newControl.propiedades['enteros'] = data.chEnteros;
            newControl.propiedades['mayorQue'] = data.chMayorQue;
            newControl.propiedades['menorQue'] = data.chMenorQue;
            newControl.propiedades['cantidadDecimales'] = data.txtCantidadDecimales;
          }
          break;
        case 'textarea':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                'Información errónea');
              break;
            }
          }
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            propiedades: {
              rows: data.txtRows,
              max: data.txtMax,
              min: data.txtMin,
              transform: data.cboTransform,
            },
            orden: 0,
            unico: data.chOnly,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          break;
        case 'checkbox':
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.numFilas,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: '',
            tooltip: data.txtTooltip,
            orden: 0,
            unico: data.chOnly,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            propiedades: {
              default: data.cboDefault
            },
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          break;
        case 'email':
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            orden: 0,
            unico: data.chOnly,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            propiedades: {
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp
            },
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          break;
        case 'date-time-picker':
          let placeholder = 'DD/MM/YYYY';
          switch (data.cboTypePicker) {
            case 'timer':
              placeholder = 'HH:MM';
              break;
            case 'dateTimer':
              placeholder = 'DD/MM/YYYY HH:MM';
              break;
            case 'rangeDate':
              placeholder = 'DD/MM/YYYY - DD/MM/YYYY';
              break;
            case 'rangeTime':
              placeholder = 'HH:MM - HH:MM';
              break;
            case 'range':
              placeholder = 'DD/MM/YYYY HH:MM - DD/MM/YYYY HH:MM';
              break;
          }
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: placeholder,
            tooltip: data.txtTooltip,
            orden: 0,
            unico: data.chOnly,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: []
            },
            propiedades: {
              tipo: data.cboTypePicker,
              fechaDesde: data.txtDesde,
              fechaHasta: data.txtHasta,
              habiles: data.txtHabiles,
            },
            maestra_dependencia: null,
            alias: data.txtAlias,
          };
          break;
        case 'ngSelect':
          newControl = {
            tipo_campo: this.typeNewControl,
            nombre: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            orden: 0,
            unico: data.chOnly,
            validaciones: {
              condiciones: this.tmpFormulariosCondictions,
              filtros: this.tmpFormulariosFilters
            },
            propiedades: {
              columnas_seleccionadas: data.selectColumn,
              tipoSelector: data.cboTipoSelect,
              auto_ajustar_tamano: data.chAutoAjustar ? data.chAutoAjustar : false,
              accionesInModal: {
                agregarInModal: data.chAgregar ? data.chAgregar : false,
                modificarInModal: data.chModificar ? data.chModificar : false,
                eliminarInModal: data.chEliminar ? data.chEliminar : false,
              },
            },
            maestra_dependencia: { id: data.cboMasterTable, nombre: '', estructura: [] },
            alias: data.txtAlias,
          };
          if (
            data.cboTipoSelect === 'EnModal' &&
            this.columnsMaster &&
            this.columnsMaster.length &&
            data.selectColumn &&
            data.selectColumn.length
          ) {
            const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
            data.selectColumn.forEach((col: string) => {
              const selectColumn = find(this.columnsMaster, { value: col });
              if (selectColumn) {
                let labelSelector = selectColumn.key.replace(':', '');
                if (selectColumn.column !== selectColumn.key) {
                  labelSelector = selectColumn.column.replace(':', '') + ' - ' + selectColumn.key.replace(':', '');
                }
                const columSelector: ColumnsTableModalSelect = {
                  key: selectColumn.value,
                  label: labelSelector,
                  type: selectColumn.type,
                  category: selectColumn.category
                };
                columnsModalSelector.push(columSelector);
              }
            });
            newControl.propiedades['columnsSelectorModal'] = columnsModalSelector;
          }

          break;
      }
      if (valid) {
        if (action === 'agregar') {
          newControl.orden = this.orderControlMax;
          this.structureMaster.push(newControl);
          this.closeForm();
          this.orderControlMax++;
        } else {
          if (this.controlSelect.id) {
            newControl.id = this.controlSelect.id;
          }
          newControl.orden = this.controlSelect.orden;
          this.structureMaster[this.indexControlSelect] = newControl;
          this.indexControlSelect = -1;
          this.editColumn = false;
          delete this.controlSelect;
          delete this.typeNewControl;
          this.modalRef.hide();
        }
        this.tmpFormulariosCondictions = [];
      }
    } else {
      this
        .toastr
        .warning('El alias ' + infoAlias.alias + ' ya esta siendo utilizado por otro campo en el formulario actual',
          'Duplicación del alias');
    }
  }

  /**
   * Guarda la estructura creada o modificada de la maestra
   *
   * @memberof MasterStructureComponent
   */
  async savedStucture() {
    try {
      const createColumn: ColumnaMaestra[] = [];
      const updateStructure: ColumnaMaestra[] = [];

      this.structureMaster.forEach(column => {
        if (column.id) {
          updateStructure.push(column);
        } else {
          createColumn.push(column);
        }
      });

      await this.msds.savedStructure(
        this.idMaster,
        createColumn,
        updateStructure,
        this.idColumsDelete
      ).subscribe(res => {
        if (res) {
          this.closeComponent(true);
        }
      });
    } catch (error) {
      log.debug(error);
    }
  }

  /**
   * Reordena el orden de los controles en el formulario
   *
   * @memberof MasterStructureComponent
   */
  reorder() {
    if (this.structureMaster) {
      for (let indexF = 0; indexF < this.structureMaster.length; indexF++) {
        this.structureMaster[indexF].orden = indexF + 1;
      }
    }
  }

  /**
   * Define la pregunta de confirmacion dependiendo de la accion a realizar
   *
   * @param {('closeComponent' | 'savedStructure' | 'deleteColumn')} [action='closeComponent']
   * @memberof MasterStructureComponent
   */
  defineComfirmAction(action: 'closeComponent' | 'savedStructure' | 'deleteColumn' = 'closeComponent') {
    this.typeAction = action;
    switch (this.typeAction) {
      case 'closeComponent':
        this.question = 'Si sale del modo de edicion de estructura los cambios realizados no se guardaran. ' +
          '¿Desea continuar?';
        break;
      case 'savedStructure':
        this.question = '¿Realmente desea guardar la estructura de la forma?';
        break;
      case 'deleteColumn':
        if (this.controlSelect.id) {
          this.question = 'Si elimina la columna puede perder informacion de registros anteriores. ' +
            '¿Desea continuar?';
        } else {
          this.question = 'Realmente desea eliminar la columna. ' +
            '¿Desea continuar?';
        }
        break;
    }
    this.confirmAction.open();
  }

  /**
   * Define la accion a realizar despues de la respuesta de la modal
   *
   * @param {boolean} res
   * @memberof MasterStructureComponent
   */
  actionComfirmClose(res: boolean) {
    if (res) {
      switch (this.typeAction) {
        case 'closeComponent':
          this.closeComponent();
          break;
        case 'savedStructure':
          this.savedStucture();
          break;
        case 'deleteColumn':
          this.deleteColumn();
          break;
      }
    }
    this.typeAction = null;
    this.question = '';
  }

  /**
   * Carga las columnas de la maestra seleccionada
   *
   * @param {*} data
   * @memberof MasterStructureComponent
   */
  async changeForm(data: any) {
    if (data.change) {
      if (data.change['cboMasterTable']) {
        if (data.change['cboMasterTable'] !== this.idMasterSelected) {
          this.idMasterSelected = data.change['cboMasterTable'];
          this.columnsMaster = [];
          this.columnsMasterFilter = [];
          const master = await this.tds.getInformacionMasterTable(this.idMasterSelected, true);
          this.columnsMaster = this.loadingColumnsViews(master.estructura, this.idMasterSelected);
          this.columnsMasterFilter = this.loadingColumnsViews(master.estructura, this.idMasterSelected, true);
          const newControl: ColumnaMaestra = {
            tipo_campo: this.typeNewControl,
            nombre: data.change.txtLabel,
            espacio: data.change.cboEspacios,
            requerido: data.change.chRequiered ? data.change.chRequiered : false,
            placeholder: data.change.txtPlaceholder,
            tooltip: data.change.txtTooltip,
            orden: 0,
            unico: data.change.chOnly,
            validaciones: {
              condiciones: [],
              filtros: []
            },
            propiedades: {
              tipoSelector: data.change.cboTipoSelect,
              auto_ajustar_tamano: data.change.chAutoAjustar ? data.change.chAutoAjustar : false,
              accionesInModal: {
                agregarInModal: data.change.chAgregar ? data.change.chAgregar : false,
                modificarInModal: data.change.chModificar ? data.change.chModificar : false,
                eliminarInModal: data.change.chEliminar ? data.change.chEliminar : false,
              },
            },
            maestra_dependencia: { id: data.change.cboMasterTable, nombre: '', estructura: [], valores: [] },
            alias: data.change.txtAlias,
          };
          this.controls = this.msfs.getFormSelect(
            this.sizesControls,
            this.masterTables,
            this.ngSelectTpl,
            newControl,
            this.columnsMaster
          );
        }
      }
    }
  }

  /**
   * Guarda en una variable temporal las condiciones del control en creacion o edicion
   *
   * @param {Array<CondicionControl>} condictions
   * @memberof MasterStructureComponent
   */
  savedCondictions(condictions: Array<CondicionControl>) {
    this.tmpFormulariosCondictions = condictions;
  }

  /**
   * Guarda en una variable temporal los filtros del control en creacion o edicion
   *
   * @param {Array<FiltrosSelectores>} filters
   * @memberof MasterStructureComponent
   */
  savedFilters(filters: Array<FiltrosSelectores>) {
    this.tmpFormulariosFilters = filters;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/master-structure.component.ts